const LOCAL_STORAGE_ID = 'preferencias'

const DEFAULT_KEYS = [
  'gate',
  'tipo_operacao',
  'fornecedor',
  'tipo_frete',
  'terminal',
  'produto',
  'sub_produto',
  'regiao',
]

class Preferencias {
  default = {
    gate: null,
    tipo_operacao: null,
    fornecedor: null,
    tipo_frete: null,
    terminal: null,
    produto: null,
    sub_produto: null,
    regiao: [],
  }
  constructor(empresaId) {
    this.empresaId = empresaId
    this.storage_id = empresaId
      ? `${LOCAL_STORAGE_ID}-${empresaId}`
      : LOCAL_STORAGE_ID
    this._data = this._loadData()
  }
  _isFlatFormat(stored) {
    if (!stored || typeof stored !== 'object') return false
    return DEFAULT_KEYS.some((key) => key in stored)
  }
  _migrateLegacy() {
    const legacy = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ID))
    if (!legacy || !this.empresaId) return null

    if (this._isFlatFormat(legacy)) {
      return { ...this.default, ...legacy }
    }

    if (legacy[this.empresaId]) {
      return { ...this.default, ...legacy[this.empresaId] }
    }

    return null
  }
  _loadData() {
    const stored = JSON.parse(localStorage.getItem(this.storage_id))
    if (stored) {
      return { ...this.default, ...stored }
    }

    const migrated = this._migrateLegacy()
    if (migrated) {
      localStorage.setItem(this.storage_id, JSON.stringify(migrated))
      return migrated
    }

    return { ...this.default }
  }
  getLocalStorage() {
    return JSON.parse(localStorage.getItem(this.storage_id)) || { ...this.default }
  }
  get data() {
    if (!this._data) {
      this._data = this.getLocalStorage()
    }
    return this._data
  }
  set data(data) {
    this.data = data
    this.save()
  }
  clear() {
    localStorage.setItem(this.storage_id, JSON.stringify([]))
  }
  save() {
    if (!this.empresaId) return
    localStorage.setItem(this.storage_id, JSON.stringify(this._data))
  }
  set(attr, paylod) {
    this.data[attr] = paylod
    this.save()
  }
  get gate() {
    if (!this.data) {
      this.data = this.getLocalStorage()
    }
    return this.data.gate
  }
  set gate(gate) {
    this.data.gate = gate
    this.save()
  }

  get tipo_operacao() {
    if (!this.data) {
      this.data = this.getLocalStorage()
    }
    return this.data.tipo_operacao
  }
  set tipo_operacao(tipo_operacao) {
    this.data.tipo_operacao = tipo_operacao
    this.save()
  }

  get fornecedor() {
    if (!this.data) {
      this.data = this.getLocalStorage()
    }
    return this.data.fornecedor
  }
  set fornecedor(fornecedor) {
    this.data.fornecedor = fornecedor
    this.save()
  }

  get tipo_frete() {
    if (!this.data) {
      this.data = this.getLocalStorage()
    }
    return this.data.tipo_frete
  }
  set tipo_frete(tipo_frete) {
    this.data.tipo_frete = tipo_frete
    this.save()
  }

  get regiao() {
    if (!this.data) {
      this.data = this.getLocalStorage()
    }
    return this.data.regiao
  }
  set regiao(regiao) {
    this.data.regiao = regiao
    this.save()
  }

  get terminal() {
    if (!this.data) {
      this.data = this.getLocalStorage()
    }
    return this.data.terminal
  }
  set terminal(terminal) {
    this.data.terminal = terminal
    this.save()
  }

  get produto() {
    if (!this.data) {
      this.data = this.getLocalStorage()
    }
    return this.data.produto
  }
  set produto(produto) {
    this.data.produto = produto
    this.save()
  }


  get sub_produto() {
    if (!this.data) {
      this.data = this.getLocalStorage()
    }
    return this.data.sub_produto
  }
  set sub_produto(sub_produto) {
    this.data.sub_produto = sub_produto
    this.save()
  }

}

export { Preferencias, LOCAL_STORAGE_ID }
